// extracted by mini-css-extract-plugin
export default {"cta":"CG-z","disabled":"DG-z"};